import { createActions } from 'redux-actions';

const actions = createActions(
  {
    COUNTDOWN: {
      BEGIN: endTime => ({ endTime }),
      END: () => undefined,
    },
    INTRODUCTION: {
      BEGIN: protocol => ({ protocol }),
      END: () => undefined,
    },
    BREAK: {
      BEGIN: duration => ({}),
      END: () => undefined,
    },
    COMPETITION: {
      BEGIN: (protocol, lift) => ({ protocol, lift }),
      END: () => undefined,
      STOP: reason => ({ reason }), // reason: jury, technical
      RESUME: undefined,
      BARBELL: {
        LOAD: undefined,
        DISINFECT: undefined,
      },
      ATHLETE: {
        ANNOUNCE: undefined,
        NOTIFY: undefined,
      },
      TIMING_CLOCK: {
        RESET: time => ({ time }),
        START: undefined,
        STOP: undefined,
      },
      REFEREE_LIGHTS: {
        RESET: undefined,
        SHOW: adjudications => ({ adjudications }),
      },
    },
    VICTORY_CEREMONY: {
      BEGIN: (contest, lift) => ({ contest, lift }),
      END: () => undefined,
    },
  },
  {
    prefix: '@@nosturi/venue',
  },
);

export default actions;



// WEBPACK FOOTER //
// ./src/venue/actions.js